export default import.meta.ROLLDOWN_FILE_URL_cqbA5FiAbC0_ukYnXhHq9A